export default "__VITE_ASSET__DGcLAWjH__"